import { reactive, watch, computed, nextTick } from "vue";
import { useStore } from "vuex";
import {
  configFieldEntries,
  inputTypeFor,
  isSelectField,
} from "@/scripts/Utilities/ConfigFields.js";

export default function useUtilityInputsContainer(props) {
  const store = useStore();
  const config = computed(() => store.getters["utilities/getConfig"]);

  const form = reactive({});

  // Every field that isn't a dropdown is a free text or number input.
  const inputConfigs = computed(() =>
    configFieldEntries(config.value).reduce((fields, [key, field]) => {
      if (!isSelectField(key, field)) {
        fields[key] = {
          title: field.title,
          type: inputTypeFor(field),
          placeholder: String(field.value ?? ""),
        };
      }
      return fields;
    }, {})
  );

  let isInitializing = false;

  const resetForm = () => {
    if (!config.value) return;

    isInitializing = true;
    Object.keys(inputConfigs.value).forEach((key) => {
      form[key] = config.value[key].value;
    });

    nextTick(() => {
      isInitializing = false;
    });
  };

  watch(
    () => ({ ...form }),
    (newForm, oldForm) => {
      if (isInitializing) return;

      Object.keys(newForm).forEach((key) => {
        // Emit update if the value actually changed
        if (newForm[key] !== oldForm[key]) {
          props.updateFieldObject(key, newForm[key]);
        }
      });
    },
    { deep: true }
  );

  return {
    form, // Return the reactive object directly
    inputConfigs,
    resetForm,
  };
}
